<template>
  <v-card class="pb-8">
    <v-card-text>
    <v-toolbar dense flat dark color="primary">
      <v-toolbar-title>A/B Testing</v-toolbar-title>
      <v-subheader class="bold">Pick a variable to test</v-subheader>
    </v-toolbar>

      <v-row>
        <v-col md="3">
          <v-hover v-slot="{ hover }">
            <v-card
              min-width="110"
              max-width="200"
              :elevation="hover ? 16 : 2"
              dark
              :class="{ 'on-hover': hover }"
              class="mx-auto text-center"
              color="teal"
              @click="createSplitTest('subject')"
            >
              <v-card-title class="justify-center">Subject</v-card-title>
              <v-divider dark></v-divider>
              <v-icon x-large dark class="pa-6">mdi-plus-circle</v-icon>
            </v-card>
          </v-hover>
        </v-col>

        <v-col md="3">
          <v-hover v-slot="{ hover }">
            <v-card
              min-width="110"
              max-width="200"
              :elevation="hover ? 16 : 2"
              dark
              :class="{ 'on-hover': hover }"
              class="mx-auto text-center"
              color="teal"
              @click="createSplitTest('sender')"
            >
              <v-card-title class="justify-center">Sender</v-card-title>
              <v-divider dark></v-divider>
              <v-icon x-large dark class="pa-6">mdi-plus-circle</v-icon>
            </v-card>
          </v-hover>
        </v-col>

        <v-col md="3">
          <v-hover v-slot="{ hover }">
            <v-card
              min-width="110"
              max-width="200"
              :elevation="hover ? 16 : 2"
              dark
              :class="{ 'on-hover': hover }"
              class="mx-auto text-center"
              color="teal"
              @click="createSplitTest('content')"
            >
              <v-card-title class="justify-center">Content</v-card-title>
              <v-divider dark></v-divider>
              <v-icon x-large dark class="pa-6">mdi-plus-circle</v-icon>
            </v-card>
          </v-hover>
        </v-col>

        <v-col md="3">
          <v-hover v-slot="{ hover }">
            <v-card
              min-width="110"
              max-width="200"
              :elevation="hover ? 16 : 2"
              dark
              :class="{ 'on-hover': hover }"
              class="mx-auto text-center"
              color="teal"
              @click="createSplitTest('time')"
            >
              <v-card-title class="justify-center">Time</v-card-title>
              <v-divider dark></v-divider>
              <v-icon x-large dark class="pa-6">mdi-plus-circle</v-icon>
            </v-card>
          </v-hover>
        </v-col>

      </v-row>
      <!-- </v-container> -->
    </v-card-text>
    <v-card-actions class="justify-center mt-4">
      <v-btn @click="$emit('cancel', true)">Cancel</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { EmailCampaignApi } from '@/services'

export default {
  name: 'split-test-setup',
  props: {
    emailCampaignId: {
      type: [Number, String],
      required: true
    }
  },
  data () {
    return {}
  },
  computed: {},
  methods: {
    createSplitTest: function (testType) {
      EmailCampaignApi.createSplitTest(this.emailCampaignId, testType)
        .then(resp => {
          this.$emit('split-test-created', resp.data)
        })
        .catch(error => {
          this.$logger.error(error.message)
          // TODO - emit something
        })
    }
  }
}
</script>

<style lang="sass" scoped>
.v-card.on-hover.theme--dark
  background-color: rgba(#FFF, 0.8)
  >.v-card__text
    color: #000
</style>
